import { api } from ".";

/**
 * Benefits reporting (CLE-2365). SuperAdmin-only on the backend; stores a report
 * that an auto-selected eligibility benefit was wrong (manual change or button).
 */
const benefitReportsQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    createBenefitReport: builder.mutation({
      query: ({ body }) => ({
        url: "benefit-reports",
        method: "POST",
        body,
      }),
    }),
  }),
});

export const { useCreateBenefitReportMutation } = benefitReportsQueries;
